<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center
            append-to-body>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">反馈信息</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form class="form" :model="ruleForm" ref="ruleForm" labelWidth="auto">
                <blockquote v-for="(item,index) in ruleForm.lists" :key="index">
                    <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                                  :rules="item.state === 1 ?{required: true, message: `请输入${item.name}`, trigger: 'blur'} : ''"
                                  v-if="item.type === 1">
                        <el-input v-model="item.value" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                    <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                                  :rules="item.state === 1 ?{required: true, message: `请输入${item.name}`, trigger: 'blur'} : ''"
                                  v-if="item.type === 2">
                        <el-input v-model="item.value" placeholder="请输入" type="textarea" resize="none"
                                  :autosize="{ minRows: 6, maxRows: 6 }" :disabled="readonly">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                                  :rules="item.state === 1 ?{required: true, message: `请选择${item.name}`, trigger: 'change'} : ''"
                                  v-if="item.type === 3" >
                        <el-select v-model="item.value" :disabled="readonly">
                            <el-option
                                    v-for="option in item.option"
                                    :key="option"
                                    :label="option"
                                    :value="option">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                                  :rules="item.state === 1 ?{required: true, message: `请选择${item.name}`, trigger: 'change'} : ''"
                                  v-if="item.type === 4">
                        <el-select v-model="item.value" multiple :disabled="readonly">
                            <el-option
                                    v-for="option in item.option"
                                    :key="option"
                                    :label="option"
                                    :value="option">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                                  :rules="item.state === 1 ?{required: true, message: `请上传${item.name}`, trigger: 'change'} : ''"
                                  v-if="item.type === 5">
                        <el-upload
                                class="upload-demo"
                                :class="{readonly:readonly}"
                                :action="fileUpUrl"
                                :data="QiniuData"
                                :file-list="item.value"
                                :on-error="uploadError"
                                :on-success="(response, file, fileList)=>{return uploadSuccess(response,file,fileList,index)}"
                                :before-upload="(file)=>{return beforeAvatarUpload(file,index)}"
                                :on-remove="(file, fileList)=>{return handleRemove(file, fileList,index)}"
                                :on-preview="onPreview"
                                :disabled="readonly">
                            <el-button size="small" type="primary" v-if="!readonly">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                </blockquote>
            </el-form>
            <div class="dialog-operate flex align-center justify-center" v-if="!readonly && user.isBranch">
                <el-button class="operate black" @click="cancel">稍后再填</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    立即提交
                </el-button>
            </div>
            <div class="dialog-operate flex align-center justify-center" v-else>
                <el-button class="operate black" @click="cancel">取消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {getNoticeDetail,feedbackNotice} from '@/api/branch'
    import {fileUpUrl, filePath} from '@/config/index'
    import {genUpToken} from '@/utils/CryptoJS'

    export default {
        name: "NoticeFeedbackDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            nid: { //详情ID
                type: Number,
            },
        },
        data() {
            return {
                loading: false,
                readonly: false,
                ruleForm: {
                    lists: [],
                },
                QiniuData: {
                    fname: '', //  文件名
                    key: '', //文件名字处理
                    token: genUpToken() //七牛云token
                },
                fileUpUrl: fileUpUrl,
            }
        },
        created() {
            if (this.nid && this.applyDialogVisible)this.init()
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        methods: {
            async init() {
                let _data = await  getNoticeDetail(this.nid)
                if (_data.status === 200) {
                    if(_data.data.is_feedback){
                        this.readonly = true
                        this.ruleForm.lists =  _data.data.user_feedback ? JSON.parse(_data.data.user_feedback) : []
                        this.ruleForm.lists.map(item=>{
                            item.type = Number(item.type)
                            item.state = Number(item.state)
                        })
                    }else{
                        this.ruleForm.lists =  _data.data.feedback_json ? JSON.parse(_data.data.feedback_json) : []
                        this.ruleForm.lists.map(item=>{
                            item.type = Number(item.type)
                            item.state = Number(item.state)
                            if (item.type === 5 ){
                                item.value = []
                            }
                        })
                    }


                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.applyServer();
                    }
                });
            },
            async applyServer() {
                this.loading = true
                let _data = await feedbackNotice(this.nid,JSON.stringify(this.ruleForm.lists))
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.init()
                    this.$emit('feedbackState', true)
                }
            },
            cancel() {
                this.clearContent()
                this.$emit('feedbackState', false)
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            //  上传成功
            uploadSuccess(response, file, fileList, index) {
                this.uping.close();
                this.ruleForm.lists[index].value.push({
                    name: file.name,
                    url: `${filePath}/${response.key}`
                })
            },
            onPreview(file){
                window.open(file.url)
            },
            handleRemove(file, fileList,index) {
                console.log(file)
                console.log(fileList)
                this.ruleForm.lists[index].value.splice(index,1)
            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
            beforeAvatarUpload(file) {
                this.QiniuData.fname = file.name;
                this.QiniuData.key = `${new Date().getTime()}${file.name}`
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
        },
        watch: {
            applyDialogVisible() {
                if (this.nid && this.applyDialogVisible) {
                    this.detail = ''
                    this.init()
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-select{
        width: 100%;
    }

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                overflow-y: scroll;
                &::-webkit-scrollbar {
                    display: none
                }

            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>